import Button from '@material-ui/core/Button';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Symbol from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/Symbol';
import { Box, IconButton, Typography } from '@material-ui/core';
import GoLongShort from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/GoLongShort';
import LongShortCheckBoxes from '../Components/LongShortCheckBoxes';
import { CreateTacticTextField } from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/CreateTradePlanTree';
import QuantityBasisValueTxtBox from '../Components/QtyBasisValueTxtBox';
import QuickSetups from '../Components/QuickSetups';
import QuickEntries from '../Components/QuickEntries';
import InstrumentRadios from '../Components/InstrumentRadios';
import { dataValidation } from '../../../../forms/tradeplans/AddTradePlan/DataValidation';
import PushMessage from '../../../pushmessages/PushMessage';
import CloseIcon from '@material-ui/icons/Close';
import OptionControls from '../Components/OptionControls';
import OptionChainStrategyCheckboxes from '../Components/OptionChainStrategyCheckboxes';
import OptionsFiltersTree from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/OptionFilters';
import SetupFiltersTree from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/SetupFiltersTree';
import SymbolComponent from '../Components/SymbolComponent';
import WorkOrderComponent from '../Components/WorkOrderComponent';
import { selectOptionsBasedOnShortCuts } from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/OptionChains';
import RestartOncePositionHasFlattenedComponent from '../Components/RestartOncePositionHasFlattened';
import TradePlanTitleWrapper from '../../../../atomic/formElements/tradePlanTitleWrapper/TradePlanTitleWrapper';
import ExitTacticsContainer from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/exitTacticsContainer/ExitTacticsContainer';
import CloseWindowButton from '../../../../atomic/buttons/closeWindow/CloseWindowButton';
import style from './TradePlanSetup.module.css';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';
import { colors } from '../../../../../colorVars';
import ExpandingTitleWrapper from '../../../../atomic/formElements/expandingTitleWrapper/ExpandingTitleWrapper';
import { addTradePlan } from '../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/addtradeplanmessage/addTradePlan';

const boxProps = {
  bgcolor: 'background.paper',
  //m: 1,
  //style: { width: "5rem", height: "5rem" },
  borderColor: 'text.primary',
  width: '100%',
  height: '100%',
};

const OPTION_INSTRUMENTS = ['option', 'future_option'];
export default function TradePlanSetup({
  componentSymbol,
  top,
  data,
  dispatchTop,
  setViewOptionManagementEnabled,
  setOptionChains,
  setOptionChoices,
  symbolsUsed,
  setSymbolsUsed,
  marketOrderEnabled,
  marketOrder,
  setMarketOrderEnabled,
  dispatchMarketOrder,
  limitOrderEnabled,
  limitOrder,
  setLimitOrderEnabled,
  dispatchLimitOrder,
  candleBreakEnabled,
  candleBreak,
  setCandleBreakEnabled,
  dispatchCandleBreak,
  setupFields,
  dispatchSetUpDetails,
  defaultQtyBasisValue,
  lossLimit,
  dispatchLossLimit,
  lossLimitEnabled,
  setLossLimitEnabled,
  preserveProfit,
  dispatchPreserveProfit,
  preserveProfitEnabled,
  setPreserveProfitEnabled,
  positionPriceTrail,
  dispatchPositionPriceTrail,
  positionPriceTrailEnabled,
  setPositionPriceTrailEnabled,
  underlyingPriceTrail,
  dispatchUnderlyingPriceTrail,
  underlyingPriceTrailEnabled,
  setUnderlyingPriceTrailEnabled,
  candleTrail,
  dispatchCandleTrail,
  candleTrailEnabled,
  setCandleTrailEnabled,
  grabCents,
  dispatchGrabCents,
  grabCentsEnabled,
  setGrabCentsEnabled,
  grabCentsMode,
  setGrabCentsMode,
  greenToRedCandles,
  dispatchGreenToRedCandles,
  greenToRedCandlesEnabled,
  setGreenToRedCandlesEnabled,
  greenToRedPositions,
  dispatchGreenToRedPositions,
  greenToRedPositionsEnabled,
  setGreenToRedPositionsEnabled,
  breakPrice,
  dispatchBreakPrice,
  breakPriceEnabled,
  setBreakPriceEnabled,
  positionBreakPrice,
  dispatchPositionBreakPrice,
  positionBreakPriceEnabled,
  setPositionBreakPriceEnabled,
  candleMagnitude,
  dispatchCandleMagnitude,
  candleMagnitudeEnabled,
  setCandleMagnitudeEnabled,
  ratchetBracket,
  dispatchRatchetBracket,
  ratchetBracketEnabled,
  setRatchetBracketEnabled,
  symbolsRemaining,
  setClickedSubmit,
  setSubmitMessageDetails,
  configTitle,
  storedConfigKey,
  isSavedConfigDirty,
  submitMessageDetails,
  clickedSubmit,
  index,
  deleteIndex,
  setExpirationDates,
  maxOptionPriceBarrier,
  setMaxOptionPriceBarrier,
  minOptionPriceBarrier,
  setMinOptionPriceBarrier,
  optionChains,
  tightSpreadPctEnabled,
  setTightSpreadPctEnabled,
  tightSpreadPct,
  dispatchTightSpreadPct,
  optionPriceRangeEnabled,
  setOptionPriceRangeEnabled,
  optionPriceRange,
  dispatchOptionPriceRange,
  expirationDates,
  optionChoices,
  optionShortCutsPackage,
  selectAll,
  callType,
  putType,
  setOtm1Enabled,
  setHugCurrentPriceEnabled,
  setItm1Enabled,
  dispatchOtm1,
  dispatchItm1,
  otm1Enabled,
  itm1Enabled,
  hugCurrentPriceEnabled,
  tightSpreadCentsEnabled,
  setTightSpreadCentsEnabled,
  tightSpreadCents,
  dispatchTightSpreadCents,
  qtyRangeEnabled,
  setQtyRangeEnabled,
  qtyRange,
  dispatchQtyRange,
  dollarRangeEnabled,
  setDollarRangeEnabled,
  dollarRange,
  dispatchDollarRange,
  priceIntersectsFirstCandleEnabled,
  setPriceIntersectsFirstCandleEnabled,
  priceIntersectsFirstCandle,
  dispatchPriceIntersectsFirstCandle,
  emaIntersectsFirstCandleEnabled,
  setEmaIntersectsFirstCandleEnabled,
  emaIntersectsFirstCandle,
  dispatchEmaIntersectsFirstCandle,
  timeOfDay,
  dispatchTimeOfDay,
  timeOfDayEnabled,
  setTimeOfDayEnabled,
  ftfcFilter,
  dispatchFtfcFilter,
  ftfcFilterEnabled,
  setFtfcFilterEnabled,
  buyOrSellOption,
  userPreferences,
  otmEnabled,
  itmEnabled,
  notExpiringToday,
  setNotExpiringToday,
  atrTrail,
  dispatchAtrTrail,
  atrTrailEnabled,
  setAtrTrailEnabled,
  mfeRetracementEnabled,
  setMfeRetracementEnabled,
  mfeRetracement,
  dispatchMfeRetracement,
  underlyingPriceExitEnabled,
  setUnderlyingPriceExitEnabled,
  underlyingPriceExit,
  dispatchUnderlyingPriceExit,
  // EnterTradePlan,
  //handleEnterNow,
  //     finishedRenderingOptionChain,
  //   setFinishedRenderingOptionChain
}) {
  const [finishedRenderingOptionChain, setFinishedRenderingOptionChain] =
    useState(true);
  const [enterNow, setEnterNow] = useState(false);
  //const
  useEffect(() => {
    if (enterNow) {
      //} && letEnterNowKnowOptionsDone) {
      //      console.log("calling enter now");
      //    console.log(callType);
      //  console.log(putType);
      //console.log(optionChoices);
      EnterTradePlan();
      setEnterNow(false);
      //setLetEnterNowKnowOptionsDone(false);
    }
  }, [enterNow]); //, letEnterNowKnowOptionsDone]);

  function handleEnterNow(goLong) {
    let defaultOptionRadio =
      userPreferences['userPreferences']['optionRadioButtons'];
    if (buyOrSellOption === 'LONG') {
      if (goLong && !top.goLong) {
        //select calls
        //console.log("handling enterNow: " + defaultOptionRadio);
        //setCallType(defaultOptionRadio);
        //setPutType("none");
        selectOptionsBasedOnShortCuts(
          selectAll,
          defaultOptionRadio, //put this as default call type, bc react does not update state sync
          'none', //put this as put type, bc react does not update state sync
          optionChoices,
          setOptionChoices,
          optionChains,
          finishedRenderingOptionChain,
          setFinishedRenderingOptionChain
        );
      } else if (!goLong && !top.goShort) {
        //select puts
        //setPutType(defaultOptionRadio);
        //setCallType("none");
        selectOptionsBasedOnShortCuts(
          selectAll,
          'none', //put this as call type, bc react does not update state sync
          defaultOptionRadio, //put this as default put type, bc react does not update state sync
          optionChoices,
          setOptionChoices,
          optionChains,
          finishedRenderingOptionChain,
          setFinishedRenderingOptionChain
        );
      }
    } else {
      if (goLong) {
        selectOptionsBasedOnShortCuts(
          selectAll,
          'none', //put this as call type, bc react does not update state sync
          defaultOptionRadio, //put this as default put type, bc react does not update state sync
          optionChoices,
          setOptionChoices,
          optionChains,
          finishedRenderingOptionChain,
          setFinishedRenderingOptionChain
        );
      } else if (!goLong) {
        //select calls
        selectOptionsBasedOnShortCuts(
          selectAll,
          defaultOptionRadio, //put this as default call type, bc react does not update state sync
          'none', //put this as put type, bc react does not update state sync
          optionChoices,
          setOptionChoices,
          optionChains,
          finishedRenderingOptionChain,
          setFinishedRenderingOptionChain
        );
      }
    }
    dispatchTop({ setup: 'AD_HOC', goLong: goLong, goShort: !goLong });
    setPriceIntersectsFirstCandleEnabled(false);
    setFtfcFilterEnabled(false);
    setEmaIntersectsFirstCandleEnabled(false);
    setTimeOfDayEnabled(false);
    let qtyBasisValue;
    if (marketOrderEnabled) {
      qtyBasisValue = marketOrder.quantityBasisValue;
    } else if (candleBreakEnabled) {
      qtyBasisValue = candleBreak.quantityBasisValue;
      setCandleBreakEnabled(false);
    } else if (limitOrderEnabled) {
      qtyBasisValue = limitOrder.quantityBasisValue;
      setLimitOrderEnabled(false);
    } else {
      qtyBasisValue = defaultQtyBasisValue;
    }
    setMarketOrderEnabled(true);
    dispatchMarketOrder({ quantityBasisValue: qtyBasisValue });
    setEnterNow(true);
    // evt.preventDefault();
  }

  function EnterTradePlan(evt) {
    //if (submitFunction === AddTradePlan) {
    let [validForm, message] = dataValidation(
      data,
      symbolsRemaining,
      finishedRenderingOptionChain
    );
    if (!validForm) {
      //alert(message);
      if (evt !== undefined) {
        evt.preventDefault();
      }
      setClickedSubmit(true);
      setSubmitMessageDetails({
        severityScore: 'error',
        message: message,
      });
      return;
    }
    //}
    if (evt !== undefined) {
      evt.preventDefault();
    }
    if (data.optionManagement !== undefined) {
      data.optionManagement.notExpiringToday = undefined; //this is ONLY so frontend can use this. no need to pass to backend
    }
    //provide datasource so tradeplan can setup options from within json converter
    if (data.optionManagement !== undefined) {
      if (data.optionManagement.optionChoices !== undefined) {
        data.optionManagement.optionChoices.dataSource = data.dataSource;
      }
    }
    //savedConfigChanged
    if (!isSavedConfigDirty) {
      data['savedConfigurationTitle'] = configTitle;
    }
    addTradePlan({
      tradePlanObject: data,
      key: storedConfigKey,
      configName: configTitle,
    });
    setClickedSubmit(true);
    setSubmitMessageDetails({
      severityScore: 'success',
      message: 'submitted',
    });
  }

  const [optionsAvailable, setOptionsAvailable] = useState(0);
  /*  console.log([
    mfeRetracementEnabled,
    setMfeRetracementEnabled,
    mfeRetracement,
    dispatchMfeRetracement,
  ]); */
  //console.log(optionShortCutsPackage);
  return (
    <div className={style.outerContainer}>
      <div className={style.topControls}>
        <CloseWindowButton
          width={20}
          color="red"
          stroke={3}
          handleClick={() => deleteIndex(index)}
        />

        <SymbolComponent
          componentSymbol={componentSymbol}
          top={top}
          dispatchTop={dispatchTop}
          finishedRenderingOptionChain={finishedRenderingOptionChain}
          setFinishedRenderingOptionChain={setFinishedRenderingOptionChain}
          setOptionChains={setOptionChains}
          setOptionChoices={setOptionChoices}
        />
        <TextButton
          color={colors.white}
          backgroundColor={colors.blue}
          width="25%"
          clickHandler={EnterTradePlan}
          fontSize="small"
        >
          Create Trade Plan
        </TextButton>
        <TextButton
          clickHandler={() => handleEnterNow(true)}
          color={colors.white}
          backgroundColor={colors.green}
          width="100px"
          fontSize="small"
        >
          Open Long
        </TextButton>
        <TextButton
          clickHandler={() => handleEnterNow(false)}
          color={colors.white}
          backgroundColor={colors.red}
          width="100px"
          fontSize="small"
        >
          Open Short
        </TextButton>
        {/* <input
          //onKeyPress="return event.keyCode!=13"
          width={'50%'}
          height={'50%'}
          type="submit"
          className="btn btn-primary m-2 addTradePlan"
          value={'CREATE TRADE PLAN'}
          onClick={(evt) => EnterTradePlan(evt)}
        /> */}
      </div>
      <div className={style.radios}>
        <InstrumentRadios
          top={top}
          dispatchTop={dispatchTop}
          setViewOptionManagementEnabled={setViewOptionManagementEnabled}
        />
        <div className={style.verticalDivider}></div>
        <LongShortCheckBoxes
          top={top}
          dispatchTop={dispatchTop}
          usedSymbols={[symbolsUsed, setSymbolsUsed]}
          labelPlacement={'top'}
        />
        <div className={style.verticalDivider}></div>
        <WorkOrderComponent top={top} dispatchTop={dispatchTop} />
        <RestartOncePositionHasFlattenedComponent
          top={top}
          dispatchTop={dispatchTop}
        />
      </div>
      {OPTION_INSTRUMENTS.includes(top.instrument) ? (
        <OptionControls
          setExpirationDates={setExpirationDates}
          setSymbolsUsed={setSymbolsUsed}
          symbolsUsed={symbolsUsed}
          setOptionChains={setOptionChains}
          maxOptionPriceBarrier={maxOptionPriceBarrier}
          setMaxOptionPriceBarrier={setMaxOptionPriceBarrier}
          minOptionPriceBarrier={minOptionPriceBarrier}
          setMinOptionPriceBarrier={setMinOptionPriceBarrier}
          setOptionChoices={setOptionChoices}
          optionChains={optionChains}
          tightSpreadPctEnabled={tightSpreadPctEnabled}
          setTightSpreadPctEnabled={setTightSpreadPctEnabled}
          tightSpreadPct={tightSpreadPct}
          dispatchTightSpreadPct={dispatchTightSpreadPct}
          optionPriceRangeEnabled={optionPriceRangeEnabled}
          setOptionPriceRangeEnabled={setOptionPriceRangeEnabled}
          optionPriceRange={optionPriceRange}
          dispatchOptionPriceRange={dispatchOptionPriceRange}
          finishedRenderingOptionChain={finishedRenderingOptionChain}
          setFinishedRenderingOptionChain={setFinishedRenderingOptionChain}
          top={top}
          expirationDates={expirationDates}
          notExpiringToday={notExpiringToday}
          optionChoices={optionChoices}
          optionShortCutsPackage={optionShortCutsPackage}
          selectAll={selectAll}
          callType={callType}
          putType={putType}
          setOtm1Enabled={setOtm1Enabled}
          setItm1Enabled={setItm1Enabled}
          setHugCurrentPriceEnabled={setHugCurrentPriceEnabled}
          dispatchItm1={dispatchItm1}
          dispatchOtm1={dispatchOtm1}
          otm1Enabled={otm1Enabled}
          itm1Enabled={itm1Enabled}
          hugCurrentPriceEnabled={hugCurrentPriceEnabled}
          tightSpreadCentsEnabled={tightSpreadCentsEnabled}
          tightSpreadCents={tightSpreadCents}
          qtyRangeEnabled={qtyRangeEnabled}
          qtyRange={qtyRange}
          dollarRange={dollarRange}
          dollarRangeEnabled={dollarRangeEnabled}
          otmEnabled={otmEnabled}
          itmEnabled={itmEnabled}
          entryTactics={data.entryTactics}
          setNotExpiringToday={setNotExpiringToday}
          optionsAvailable={optionsAvailable}
          setOptionsAvailable={setOptionsAvailable}
          ds={top.dataSource}
          goLong={top.goLong}
          goShort={top.goShort}
          symbol={top.symbol}
        />
      ) : null}
      <Grid item xs={12} container>
        {OPTION_INSTRUMENTS.includes(top.instrument) ? (
          <Grid item xs={5}>
            <OptionsFiltersTree
              optionsAvailable={optionsAvailable}
              optionPriceRange={[
                optionPriceRangeEnabled,
                setOptionPriceRangeEnabled,
                optionPriceRange,
                dispatchOptionPriceRange,
              ]}
              tightSpreadPct={[
                tightSpreadPctEnabled,
                setTightSpreadPctEnabled,
                tightSpreadPct,
                dispatchTightSpreadPct,
              ]}
              tightSpreadCents={[
                tightSpreadCentsEnabled,
                setTightSpreadCentsEnabled,
                tightSpreadCents,
                dispatchTightSpreadCents,
              ]}
              qtyRange={[
                qtyRangeEnabled,
                setQtyRangeEnabled,
                qtyRange,
                dispatchQtyRange,
              ]}
              dollarRange={[
                dollarRangeEnabled,
                setDollarRangeEnabled,
                dollarRange,
                dispatchDollarRange,
              ]}
              top={top}
              startExpanded={false}
            />
          </Grid>
        ) : null}
        <Grid item xs={7}>
          <SetupFiltersTree
            top={top}
            dispatchTop={dispatchTop}
            setupFilters={[
              priceIntersectsFirstCandleEnabled,
              setPriceIntersectsFirstCandleEnabled,
              priceIntersectsFirstCandle,
              dispatchPriceIntersectsFirstCandle,
              emaIntersectsFirstCandleEnabled,
              setEmaIntersectsFirstCandleEnabled,
              emaIntersectsFirstCandle,
              dispatchEmaIntersectsFirstCandle,
              timeOfDay,
              dispatchTimeOfDay,
              timeOfDayEnabled,
              setTimeOfDayEnabled,
              ftfcFilter,
              dispatchFtfcFilter,
              ftfcFilterEnabled,
              setFtfcFilterEnabled,
            ]}
          />
        </Grid>
      </Grid>
      <QuickSetups
        top={top}
        dispatchTop={dispatchTop}
        setupFields={setupFields}
        dispatchSetUpDetails={dispatchSetUpDetails}
      />
      <TradePlanTitleWrapper title="Entries">
        <QuickEntries
          top={top}
          dispatchTop={dispatchTop}
          marketOrderEnabled={marketOrderEnabled}
          setMarketOrderEnabled={setMarketOrderEnabled}
          dispatchMarketOrder={dispatchMarketOrder}
          marketOrder={marketOrder}
          limitOrderEnabled={limitOrderEnabled}
          setLimitOrderEnabled={setLimitOrderEnabled}
          dispatchLimitOrder={dispatchLimitOrder}
          limitOrder={limitOrder}
          candleBreakEnabled={candleBreakEnabled}
          setCandleBreakEnabled={setCandleBreakEnabled}
          dispatchCandleBreak={dispatchCandleBreak}
          candleBreak={candleBreak}
          data={data}
          defaultQtyBasisValue={defaultQtyBasisValue}
        />
      </TradePlanTitleWrapper>
      <ExpandingTitleWrapper
        title="Exit Tactics"
        list={Object.keys(data.exitTactics)}
        fixSnakeCase
      >
        <ExitTacticsContainer
          lossLimit={[
            lossLimit,
            dispatchLossLimit,
            lossLimitEnabled,
            setLossLimitEnabled,
          ]}
          preserveProfit={[
            preserveProfit,
            dispatchPreserveProfit,
            preserveProfitEnabled,
            setPreserveProfitEnabled,
          ]}
          positionPriceTrail={[
            positionPriceTrail,
            dispatchPositionPriceTrail,
            positionPriceTrailEnabled,
            setPositionPriceTrailEnabled,
          ]}
          underlyingPriceTrail={[
            underlyingPriceTrail,
            dispatchUnderlyingPriceTrail,
            underlyingPriceTrailEnabled,
            setUnderlyingPriceTrailEnabled,
          ]}
          candleTrail={[
            candleTrail,
            dispatchCandleTrail,
            candleTrailEnabled,
            setCandleTrailEnabled,
          ]}
          atrTrail={[
            atrTrail,
            dispatchAtrTrail,
            atrTrailEnabled,
            setAtrTrailEnabled,
          ]}
          underlyingPriceExit={[
            underlyingPriceExit,
            dispatchUnderlyingPriceExit,
            underlyingPriceExitEnabled,
            setUnderlyingPriceExitEnabled,
          ]}
          mfeRetracement={[
            mfeRetracement,
            dispatchMfeRetracement,
            mfeRetracementEnabled,
            setMfeRetracementEnabled,
          ]}
          grabCents={[
            grabCents,
            dispatchGrabCents,
            grabCentsEnabled,
            setGrabCentsEnabled,
            grabCentsMode,
            setGrabCentsMode,
          ]}
          greenToRedCandles={[
            greenToRedCandles,
            dispatchGreenToRedCandles,
            greenToRedCandlesEnabled,
            setGreenToRedCandlesEnabled,
          ]}
          greenToRedPositions={[
            greenToRedPositions,
            dispatchGreenToRedPositions,
            greenToRedPositionsEnabled,
            setGreenToRedPositionsEnabled,
          ]}
          breakPrice={[
            breakPrice,
            dispatchBreakPrice,
            breakPriceEnabled,
            setBreakPriceEnabled,
          ]}
          positionBreakPrice={[
            positionBreakPrice,
            dispatchPositionBreakPrice,
            positionBreakPriceEnabled,
            setPositionBreakPriceEnabled,
          ]}
          candleMagnitude={[
            candleMagnitude,
            dispatchCandleMagnitude,
            candleMagnitudeEnabled,
            setCandleMagnitudeEnabled,
          ]}
          ratchetBracket={[
            ratchetBracket,
            dispatchRatchetBracket,
            ratchetBracketEnabled,
            setRatchetBracketEnabled,
          ]}
          top={top}
        />
      </ExpandingTitleWrapper>

      {
        <PushMessage
          message={submitMessageDetails['message']}
          severityScore={submitMessageDetails['severityScore']}
          open={clickedSubmit}
          setOpen={setClickedSubmit}
        />
      }
    </div>
    // </Box>
  );
}
